<template>
  <b-col cols="12" sm="6" md="4" lg="3" class="text-center">
    <b-row class="py-1 w-100 h-100 mx-0 text-center">
      <b-card class="w-100 text-center">
        <b-card-title class="text-left" v-if="product.offer > 0">
          <b-badge variant="info" class="text-wrap" v-if="product.offer < 100">{{ product.offer }}٪ تخفیف
          </b-badge>
          <b-badge class="background badge-rounde mr-4" v-else>
            <b-row class="px-3 text-nowrap">
              <span> هزار تومان تخفیف </span>
              <span class="ml-1"> {{ formatNumber(product.offer) }} </span>
            </b-row>
          </b-badge>
        </b-card-title>
        <b-card-title class="p-3" v-else></b-card-title>
        <router-link
            :to="{ name: 'Product', params: { name: product.raw_link } }"
        >
          <b-card-img class="embed-responsive" :src="product.thumbnail" :alt="product.name"/>
        </router-link>
        <b-card-body class="">
          <b-row class="">
            <b-card-text class="m-auto pt-1 height w-100"><span class="w-100">{{ product.name }}</span></b-card-text>
          </b-row>
          <b-row>
            <b-col class="text-center">
              <b-card-text class="mt-3 text-center ">
                <del>
                  <span class="m-auto text-center ml-auto mr-auto">{{ formatNumber(product.price) }} تومان</span>
                </del>
              </b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-center">
              <b-card-text class="mt-3 row"><span class="m-auto">{{
                  formatNumber(product.price - product.offer)
                }} تومان</span></b-card-text>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col class="p-0">
              <router-link
                  :to="{ name: 'Product', params: { name: product.raw_link } }"
              >
                <b-button pill variant="outline-secondary" size="md" class="pt-2 class-dissable-hover row">
                  <span class="pl-1 text-secondary">مشاهده و خرید</span>
                  <b-icon class="cart-color text-primary" icon="cart-fill"></b-icon>
                </b-button>
              </router-link>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-row>
  </b-col>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "ProductCard",
  props: ["product"],
  methods: {
    formatNumber
  }
};
</script>

<style scoped>
.background {
  background-color: var(--primary);
  border-radius: 40px;
  color: white;
  font-size: 0.9rem;
}

.Left {
  position: relative;
  right: 17%;
}

.border-none {
  border: none;
  background-color: white;
}

.cart-color {
  color: var(--primary);
}

.badge-rounde {
  border-bottom-right-radius: 0px !important;
}

.height {
  height: 80px !important;
}

.rounded-card {
  border-radius: 15px;
}

.card-title-height {
  height: 8%;
}


.class-dissable-hover:hover {
  background: transparent !important;
  color: var(--dark)
}

</style>